import React, { Component } from "react";
import Img from "gatsby-image";

export default class Banner extends Component {
  render() {
    const { data } = this.props;
    return (
      <div className="banner">
        <Img
          fixed={data.bannerImage.fluid}
          objectFit="cover"
          objectPosition="50% 50%"
        />
        <div className="container">
          <div className="banner-details">
            <span>Hello</span>
            <h1>I'm {data.designation}</h1>
            <h4>This is my Life by Design 2021</h4>
          </div>
        </div>
      </div>
    );
  }
}
